import { render, staticRenderFns } from "./VideoElement.vue?vue&type=template&id=44fb53a6&scoped=true&"
import script from "./VideoElement.vue?vue&type=script&lang=ts&"
export * from "./VideoElement.vue?vue&type=script&lang=ts&"
import style0 from "./VideoElement.vue?vue&type=style&index=0&id=44fb53a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fb53a6",
  null
  
)

export default component.exports